import React from 'react'
import styled from 'styled-components'
import fonts from '../../../../styled/fonts'
import colors from '../../../../styled/colors'
import { SubTitle, Text1Bold } from '../../../../components/ui/text'

const RecommendationCard = ({ dateLabel }) => {
	if (!dateLabel) return null

	return (
		<Card>
			<SubTitle
				size={fonts.fontSizes.sm}
				fontWeight={fonts.fontWeight.regular}
				color={colors.text.descriptionText}
			>
				{dateLabel ? `Todas las especialidades que buscaste tienen disponibilidad el ${dateLabel}.` : 'Las especialidades que buscaste no tienen disponibilidad en una misma fecha.'}
			</SubTitle>
			{dateLabel && (
			<Text1Bold size={fonts.fontSizes.sm} fontWeight={fonts.fontWeight.semibold}>
				Te recomendamos seleccionar esa fecha para agrupar tus consultas.
			</Text1Bold>
			)}
		</Card>
	)
}

const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 16px 20px;
	border-radius: 10px;
	background: ${props => props.theme.colors.greys.cardBackGround};
	line-height: 1.4;
    width: 100%;
    max-width: 684px;
`

export default RecommendationCard
